import React, { ComponentProps, PropsWithChildren, useRef } from 'react'
import FloatingTooltip from 'LuxKit/FloatingTooltip'
import _TooltipTrigger from './_TooltipTrigger'

interface Props extends PropsWithChildren, Omit<ComponentProps<typeof FloatingTooltip>, 'triggerRef'> {
  /**
   * Disables the tooltip behaviour
   */
  disabled?: boolean
  className?: string
  /**
   * Mounts the tooltip via a portal to ignore clipping boundaries.
   */
  portaled?: boolean
}

/**
 * Display a descriptive tooltip message when the children are hovered.
 */
function Tooltip(props: Props) {
  const { children, className, disabled, portaled, ...tooltipProps } = props
  const triggerRef = useRef<HTMLSpanElement>(null)

  return <>
    <_TooltipTrigger ref={triggerRef} className={className} disabled={disabled}>{children}</_TooltipTrigger>
    {!disabled && <FloatingTooltip {...tooltipProps} portaled={portaled} triggerRef={triggerRef} />}
  </>
}

export default Tooltip
